'use strict'

/**
 * @module header
 */

const CLASS_ACTIV = 'activ'
const CLASS_TRIGGER_OPEN = 'js-open-menu'
const CLASS_TRIGGER_CLOSE = 'js-close-menu'
const CLASS_TARGET = 'cf-header'

export default {
  /**
   * @description Initialise header
   * @returns {undefined}
   */
  init() {
    this.bind()
  },
  
  /**
   * @description Bind events on stickyNav elements
   * @returns {undefined}
   */
  bind() {
    const triggers = [CLASS_TRIGGER_OPEN, CLASS_TRIGGER_CLOSE]
    triggers.forEach((trigger) => {
      document.getElementsByClassName(trigger).item(0).bindEvent('click', this.toggleMenu)
    })
  },
  
  /**
   * @description if hash defined on load, update nav, nav links and scroll
   * @returns {undefined}
   */
  toggleMenu() {
    const target = document.getElementsByClassName(CLASS_TARGET).item(0)
    
    if (target.classList.contains(CLASS_ACTIV)) {
      target.classList.remove(CLASS_ACTIV)
    } else {
      target.classList.add(CLASS_ACTIV)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/header.js